<template>
  <base-layout>
    <div class="col-xs-12 main" slot="main">
      <div class="col-xs-12 col-md-9 col-lg-10 widgets">
        <transition name="fade">

          <div v-if="widgets" class="widgets-wrapper">

            <div class="dashboard-header">
              <h2>Agents: Current Status</h2>
            </div>

            <div class="widgets-grid">
              <dashboard-widget v-for="widget in widgets" :widget="widget" :key="widget.key"></dashboard-widget>
            </div>

          </div>
        </transition>
        <transition name="fade">
          <div v-if="tableData" class="col-xs-12 col-md-12 box">
            <div class="panel stats">
              <div class="panel-header">
                <h3>Agents</h3>
              </div>
              <div class="panel-body">
                <records-table
                  :tableData="tableData"
                  :searchContext="searchContext"
                  @search="tableSearch"
                  @download="download"
                  @showRecord="showRecord">
                </records-table>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <transition name="fade">
        <div v-show="filters" class="col-xs-12 col-md-3 col-lg-2">
          <filters :filters="filters" :renderSearch="false" @applyFilters="applyFilters"></filters>
        </div>
      </transition>
    </div>
    <div slot="modals">
      <loading-modal v-if="!loaded"></loading-modal>
      <agent-modal v-show="agentId" :agentId="agentId" @close="closeAgentModal">
      </agent-modal>
    </div>
  </base-layout>
</template>

<script>
 /**
  * https://github.com/jbaysolutions/vue-grid-layout
  */
  import Vue from 'vue';
  import Filters from 'components/elements/Filters';
  import {BaseLayout} from 'components/layouts/';
  import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
  import LsStatsTable from 'components/elements/LsStatsTable';
  import RecordsTable from 'components/elements/RecordsTable';
  import DashboardWidget from 'components/elements/DashboardWidget';

  import {AgentModal, LoadingModal} from 'components/modals';

  // Load the full build.
  var _ = require('lodash');

  export default {
    components: {
      AgentModal,
      Filters,
      BaseLayout,
      LoadingModal,
      LsChart,
      LsStatsTable,
      RecordsTable,
      DashboardWidget
    },
    data () {
      return {
        loaded: false,
        items: [],
        widgets: [],
        filters: null,
        params: {},
        tableData: null,
        searchContext: {
          page: 1,
          search: null
        },
        isLoading: true,
        error: false,
        message: "",
        agentId: null
      }
    },
    async created () {
      await this.getData(true);
    },
    computed: {
    },
    watch: {
    },
    methods: {
      tableSearch: _.debounce(async function (searchParams) {
        Object.assign(this.searchContext, searchParams);
        await this.getList();
      }, 500),
      applyFilters: _.debounce(async function (params) {
        this.params = params;
        this.searchContext = {
          page: 1,
          search: null
        }
        await this.getData();
      }, 500),
      async getWidgets() {
        let widgetsResponse = await API.agents.widgets(this.params);
        this.widgets = widgetsResponse.body;
      },
      async getList() {
        let params =  Object.assign({}, this.params, this.searchContext);
        let listResponse = await API.agents.getList(params);
        this.tableData = listResponse.body;
      },
      async getData(withFilters) {
        this.loaded = false;

        const loadFilters = withFilters || false;

        try {
          await this.getWidgets();
          await this.getList();
        } catch(err) {
          Vue.toast("Unexepected error. Cannot retrieve data from server.", {className: ['et-error']});
          console.log(err);
        }
        if (loadFilters) {
          let optionsResponse = await API.agents.options();
          this.filters = optionsResponse.body.actions.GET;
        }

        this.loaded = true;
      },
      download() {
        API.agents.download(this.params);
      },
      showRecord(agentId) {
        this.agentId = agentId;
      },
      closeAgentModal() {
        this.agentId = null;
      }
    }
 }
</script>

<style lang="scss" scoped>
  .widgets {
    .dashboard-header {
      padding: .5rem;
    }

    .widgets-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-auto-rows: auto;
      gap: .5rem;

      .panel {
        margin-bottom: 0px;
        // Let variable-height widgets (e.g. the availability table) size to
        // their content instead of being stretched to the tallest row item.
        align-self: start;
        height: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AgentAnalytics.vue?dc6b9d50